<template>
  <div class="TokenWatermarkRemoval">
    <div class="page_title">
      <el-divider>
        <div class="page_title_name">去水印平台</div>
      </el-divider>
    </div>
    <div class="page_content">
      <p class="page_content_text">去水印平台是面向图文与短视频素材的实用工具，支持图片 / 视频去水印、平台链接解析等核心功能。依托 AI 修复算法，可无痕移除抖音、快手、小红书等主流平台的边角水印与内嵌标识，高清还原原始画质。多为小程序 / 网页端，免安装、免注册，操作简单，支持批量处理，适配自媒体素材采集、内容二次创作等场景。</p>
      <el-button class="page_content_btn" @click="goToPlatform">进入平台</el-button>
      <img class="page_content_img" src="../../assets/qingye/watermark-removal-platform.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "TokenWatermarkRemoval",
  data() {
    return {
      platformUrl: "https://nomark.aobaai.com",
    };
  },
  methods: {
    goToPlatform() {
      window.open(this.platformUrl, "_blank");
    },
  },
};
</script>
<style scoped>
.TokenWatermarkRemoval {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.page_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
}
.page_title_name {
  font-weight: 600;
  font-size: 26px;
  text-align: center;
}
.page_content {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}
.page_content_text {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
  text-indent: 2em;
}
.page_content_btn {
  align-self: center;
  margin-bottom: 20px;
  background-color: #2968BD;
  border-color: #2968BD;
  color: #fff;
  border-radius: 4px;
  padding: 12px 32px;
}
.page_content_btn:hover {
  background-color: #1e4f8f;
  border-color: #1e4f8f;
  color: #fff;
}
.page_content_img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Token/WatermarkRemoval.vue